import { useNavigate } from 'react-router-dom';
import { formatDistanceUnit, formatClockTime } from '@boatnav/core';
import { useUnitsStore } from '../../app/unitsStore.js';
import { useBoatStore, activeBoat } from '../boat/boatStore.js';
import { autoRouteSupported } from '../route/depthProvider.js';
import { useAutoRouteHandoff } from '../route/autoRouteHandoff.js';
import { useDeclinationDeg, formatCourseRef } from '../nav/courseFormat.js';
import { useGotoStore } from './gotoStore.js';
import { useGotoMetrics } from './useGotoMetrics.js';
import { msg } from '../../lib/messages.js';
import './goto.css';

/** "Til <navn>: 12,4 nm · 284° · ETA 15:38" (spec 13) — a straight rhumb line,
 *  deliberately not follow-route (05): no XTE, no auto-advance, no storage.
 *  Only rendered while a pin is set. */
export function GotoChip(): JSX.Element | null {
  const target = useGotoStore((s) => s.target);
  const clear = useGotoStore((s) => s.clear);
  const distanceUnit = useUnitsStore((s) => s.distance);
  const courseRef = useUnitsStore((s) => s.courseRef);
  const declDeg = useDeclinationDeg();
  const boat = useBoatStore(activeBoat);
  const metrics = useGotoMetrics();
  const requestAutoRoute = useAutoRouteHandoff((s) => s.request);
  const navigate = useNavigate();

  if (!target) return null;

  const brg = metrics ? formatCourseRef(metrics.brgDeg, declDeg, courseRef) : '—';
  const dist = metrics ? formatDistanceUnit(metrics.distNm, distanceUnit) : '—';
  const eta = metrics?.etaMs != null ? formatClockTime(metrics.etaMs) : '—';

  const suggestRoute = (): void => {
    requestAutoRoute(target.point);
    navigate('/planlegg');
  };

  return (
    <div className="goto-chip">
      <div className="goto-chip__row">
        <span className="goto-chip__text numeral">
          {msg.goto.to} <b>{target.name}</b>: {dist} · {brg} · ETA {eta}
        </span>
        <button type="button" className="goto-chip__close" aria-label={msg.goto.clear} onClick={clear}>
          ✕
        </button>
      </div>
      {autoRouteSupported() && boat && (
        <button type="button" className="goto-chip__suggest" onClick={suggestRoute}>
          ✦ {msg.goto.suggestRoute}
        </button>
      )}
    </div>
  );
}
